import type { AnyFieldApi } from "@tanstack/react-form";

/** Convert a Tanstack Form field into props suitable for passing into a react-aria field component (eg. `TextField`) */
export function ariaTanstackFieldProps<TFieldApi extends AnyFieldApi>(api: TFieldApi) {
    const {
        handleChange,
        handleBlur,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        state: { value, meta },
    } = api;
    return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value,
        onBlur: handleBlur,
        onChange: handleChange,
        isInvalid: meta.errors.length > 0,
    };
}
